import { FAVICON_LOGO_PATH, ROUTES } from '@/shared/lib';
import { Link } from '@/shared/ui';

const Logo = () => {
  return (
    <Link to={ROUTES.ROOT}>
      <img src={FAVICON_LOGO_PATH} alt="logo" className="aspect-square w-12" />
    </Link>
  );
};

export default Logo;
